import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import { listOneclick, toggleDrawer } from './action';
import { OneClickTableConfig } from './OneClickTableConfig';
import AddOneClickDrawer from 'components/AddOneClickDrawer';
import clientReducer, { initialState as clientInitialState } from 'pages/Client/reducer';
import clientSaga from 'pages/Client/saga';

function OneClick() {
  useInjectReducer({ key: 'oneclick', reducer });
  useInjectSaga({ key: 'oneclick', saga });
  useInjectReducer({ key: 'client', reducer: clientReducer });
  useInjectSaga({ key: 'client', saga: clientSaga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [deleteModalToggle, setDeleteModalToggle] = useState(false);
  const [selectedOneclick, setselectedOneclick] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const oneclickState = useSelector((state) => state.oneclick || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = OneClickTableConfig(
      handleSearch,
      handleReset,
      editUserOneclick,
      authState.userResponsibilities,
    );
    setColumns(columns);
    dispatch(listOneclick({ page: 1, limit: 10 }));
  }, []);

  const resetPagination = () => setCurrentPage(1);

  const editUserOneclick = (portfolio) => {
    setselectedOneclick(portfolio);
    dispatch(toggleDrawer());
  };

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listOneclick(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listOneclick({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listOneclick({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card
        title="Manage One Click Apps"
        extra={
          <AddOneClickDrawer
            initialState={initialState}
            clientInitialState={clientInitialState}
            selectedOneclick={selectedOneclick}
            resetPagination={resetPagination}
            editUserOneclick={editUserOneclick}
            roleAddResponsibility={_.includes(
              authState.userResponsibilities,
              'ADD_ONECLICK_SUBTAB',
            )}
          />
        }
      >
        <Table
          columns={columns}
          loading={oneclickState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={oneclickState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={oneclickState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={oneclickState.loading}
          onChange={onPageChange}
        />
      </Card>
    </>
  );
}

export default OneClick;
